module.exports = "/home/assets/backgrounds.0d26c20a-d83b3481f826d0c8a9f90e6e08aa93a2.webp";